import Pill from 'src/components/ui/Pill';
import { PREMIUM_INTRO_CALL_URL } from 'src/components/ui/PremiumUpsellCTA';
import { useChatQuota } from '../hooks/useChatQuota';

/** Remaining-message lozenge, or the exceeded booking link. Sits on the right of the work-intent row. */
export function FreemiumQuotaStatus() {
  const { data: remainingMessages, isQuotaConfirmedZero } = useChatQuota();

  if (isQuotaConfirmedZero) {
    return (
      <Pill
        variant="error"
        size="lg"
        className="min-w-0 max-w-full shrink whitespace-normal text-left"
        href={PREMIUM_INTRO_CALL_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        Quota exceeded · resets Monday at 12am · Book a call
      </Pill>
    );
  }

  if (remainingMessages == null || remainingMessages <= 0) return null;

  return (
    <Pill variant={remainingMessages <= 1 ? 'warning' : 'info'} size="lg" className="shrink-0 whitespace-nowrap">
      {remainingMessages} {remainingMessages === 1 ? 'message' : 'messages'} available
    </Pill>
  );
}
